import Input from './Input'
import NumberFormatCurrencyInput from './NumberFormatCurrency'
import NumberFormatSSN from './NumberFormatSSN'
import NumberFormatPhoneNumber from './NumberFormatPhoneNumber'

export { NumberFormatCurrencyInput, NumberFormatSSN, NumberFormatPhoneNumber }
export default Input
